import { Injectable } from '@angular/core';
import { ITime } from './definitions';
export class AtpCoreService {
constructor() { }
/**
 * @param {?} min
 * @param {?} max
 * @return {?}
 */
public allowedTimes (min, max) {
    const /** @type {?} */ allTimes = [];
    const /** @type {?} */ nowMinHour = +min.split(':')[0];
    const /** @type {?} */ nowMaxHour = +max.split(':')[0];
    const /** @type {?} */ nowMinMin = +min.split(':')[1];
    const /** @type {?} */ nowMaxMin = +max.split(':')[1];
    for (let /** @type {?} */ i = nowMinHour; i <= nowMaxHour; i++) {
      let /** @type {?} */ j = 0, /** @type {?} */
          jDest = 59;
      if (i === nowMinHour) {
        j = nowMinMin;
      }else if (i === nowMaxHour) {
        jDest = nowMaxMin;
      }
      for (j; j <= jDest; j++) {
        const /** @type {?} */ hour = i <= 12 ? i : i - 12;
        const /** @type {?} */ minute = j;
        const /** @type {?} */ ampm = i < 12 ? 'AM' : 'PM';
        allTimes.push(hour + ':' + minute + ' ' + ampm);
      }
    }
    return allTimes;
  }
/**
 * @param {?} type
 * @return {?}
 */
public ClockMaker (type: 'minute' | 'hour'): Array<any> {
    const /** @type {?} */ items = [];
    const /** @type {?} */ timeVal = (type === 'minute') ? 60 : 12;
    const /** @type {?} */ timeStep = (type === 'minute') ? 5 : 1;
    const /** @type {?} */ timeStart = (type === 'minute') ? 0 : 1;
    const /** @type {?} */ r = 124;
    const /** @type {?} */ j = r - 25;

    for (let /** @type {?} */ min = timeStart; min <= timeVal; min += timeStep) {
      if (min !== 60) {
        const /** @type {?} */ str = String(min);
        const /** @type {?} */ x = j * Math.sin(Math.PI * 2 * (min / timeVal));
        const /** @type {?} */ y = j * Math.cos(Math.PI * 2 * (min / timeVal));

        items.push({
          time: str,
          left: (x + r - 17) + 'px',
          top: (-y + r - 17) + 'px',
          type
        });
      }
    }
    return items;
  }
/**
 * @param {?} time
 * @return {?}
 */
public TimeToString(time: ITime): string {
    const { ampm, minute, hour } = time;
    let /** @type {?} */ hh = ampm === 'PM' ? +hour + 12 : +hour;
    if (ampm === 'AM' && hh === 12) {
      hh = 0;
    }
    if ( hh === 24) {
      hh = 12;
    }
    hh = hh < 10 ? '0' + hh : /** @type {?} */(( '' + hh as any));
    const /** @type {?} */ mm = minute < 10 ? '0' + minute : minute;
    return `${hh}:${mm}`;
  }
/**
 * Converts 00:00 format to ITime object
 * @param {?} time
 * @return {?}
 */
public StringToTime (time: string): ITime {
    const [h, m] = time.split(':');
    let /** @type {?} */ hour = +h > 12 ? +h - 12 : +h;
    hour = hour === 0 ? 12 : hour;
    const /** @type {?} */ ampm = +h >= 12 ? 'PM' : 'AM';
    return {
      ampm, minute: +m, hour
    };
  }
/**
 * \@experimental
 * @param {?} ele
 * @param {?} parrentPos
 * @param {?} step
 * @return {?}
 */
public CalcDegrees (ele: any, parrentPos: any, step: number): number {
    const /** @type {?} */ clock = {
      width: ele.currentTarget.offsetWidth,
      height: ele.currentTarget.offsetHeight
    };
    const /** @type {?} */ targetX = clock.width / 2;
    const /** @type {?} */ targetY = clock.height / 2;
    const /** @type {?} */ Vx = Math.round((ele.clientX - parrentPos.left) - targetX);
    const /** @type {?} */ Vy = Math.round(targetY - (ele.clientY - parrentPos.top));
    let /** @type {?} */ radians = -Math.atan2(Vy, Vx);
    radians += 2.5 * Math.PI;

    let /** @type {?} */ degrees = Math.round(radians * 180 / Math.PI);
    const /** @type {?} */ degMod = degrees % step;
    if (degMod === 0) {
      return degrees;
    } else if (degMod >= step / 2) {
      degrees = degrees + (step - degMod);
    } else if (degMod < step / 2) {
      degrees = degrees - degMod;
    }
    return degrees;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AtpCoreService_tsickle_Closure_declarations() {
/** @type {?} */
AtpCoreService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AtpCoreService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
